export default {
    deleteMessage: 'delete_item_question',
    confirmLabel: 'delete_button',
};
